var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconoEstaSemana(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26.82 26.82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #00dbff;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.41,0C6,0,0,6,0,13.41s6,13.41,13.41,13.41,13.41-6,13.41-13.41S20.81,0,13.41,0ZM19.4,12.84c-.53.5-1.35.5-1.84,0l-3.09-3.09v9.93c0,.71-.57,1.31-1.28,1.31-.74,0-1.31-.6-1.31-1.31v-9.93l-3.05,3.09c-.53.5-1.35.5-1.84,0s-.5-1.35,0-1.84l5.29-5.29c.5-.5,1.31-.5,1.84,0l5.29,5.29c.5.5.5,1.35,0,1.84Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoEstaSemana);
export default __webpack_public_path__ + "static/media/Icono-Esta-semana.7c14ea9a161aa4de5b0cbfac27d7735e.svg";
export { ForwardRef as ReactComponent };